






import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import SaitenEditTab from "../../components/SaitenEditTab.vue";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";

export default defineComponent({
  setup(props, context){

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
      const sumup_group_id = context.root.$store.state.sumup_group.id;

      if(sumup_group_id){
        window.location.href = `/#/exam_result_notification/sign_in/${sumup_group_id}`;
      }
    });
  }
})
